"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateBasketItemsSubtotal = exports.calculateItemsSubtotal = exports.calculateItemSubtotal = exports.calculateItemOptionSubtotal = exports.calculateGmItemPrice = exports.basketItemOptionSubtotalParamsMapping = void 0;
const item_1 = require("./item");
const basketItemOptionSubtotalParamsMapping = ({ optionItem, qty: optionItemQty, category, item, }) => {
    return {
        price: (optionItem === null || optionItem === void 0 ? void 0 : optionItem.priceCustomerFacing) || (optionItem === null || optionItem === void 0 ? void 0 : optionItem.price) || 0,
        priceExTax: (optionItem === null || optionItem === void 0 ? void 0 : optionItem.priceCustomerFacingExTax) || (optionItem === null || optionItem === void 0 ? void 0 : optionItem.priceExTax) || 0,
        taxValue: (optionItem === null || optionItem === void 0 ? void 0 : optionItem.taxValueCustomerFacing) || (optionItem === null || optionItem === void 0 ? void 0 : optionItem.taxValue) || 0,
        taxRate: (optionItem === null || optionItem === void 0 ? void 0 : optionItem.taxRate) || 0,
        optionItemQty,
        optionType: (category === null || category === void 0 ? void 0 : category.optionType) || null,
        item: optionItem && category // only consider the item as "existing" if it still has an option and category
            ? item
            : null,
    };
};
exports.basketItemOptionSubtotalParamsMapping = basketItemOptionSubtotalParamsMapping;
const calculateGmItemPrice = (item, qty) => {
    const variation = (0, item_1.getGMVariation)(item);
    const unitPrice = (variation === null || variation === void 0 ? void 0 : variation.priceCustomerFacing) || (item === null || item === void 0 ? void 0 : item.price) || 0;
    const unitPriceExTax = (variation === null || variation === void 0 ? void 0 : variation.priceCustomerFacingExTax) || (item === null || item === void 0 ? void 0 : item.priceExTax) || 0;
    const unitPriceTaxValue = (variation === null || variation === void 0 ? void 0 : variation.taxValueCustomerFacing) || (item === null || item === void 0 ? void 0 : item.taxValue) || 0;
    const vendorPrice = (variation === null || variation === void 0 ? void 0 : variation.price) || (item === null || item === void 0 ? void 0 : item.price) || 0;
    const vendorPriceExTax = (variation === null || variation === void 0 ? void 0 : variation.priceExTax) || (item === null || item === void 0 ? void 0 : item.priceExTax) || 0;
    const vendorPriceTaxValue = (variation === null || variation === void 0 ? void 0 : variation.taxValue) || (item === null || item === void 0 ? void 0 : item.taxValue) || 0;
    const subtotal = unitPrice * qty;
    const subtotalExTax = unitPriceExTax * qty;
    const subTotalTaxValue = unitPriceTaxValue * qty;
    const vendorSubtotal = vendorPrice * qty;
    const vendorSubtotalExTax = vendorPriceExTax * qty;
    const vendorSubtotalTaxValue = vendorPriceTaxValue * qty;
    const standardCommissionRate = ((variation === null || variation === void 0 ? void 0 : variation.standardCommissionRate) || 0) / 100;
    const reducedCommissionRate = ((variation === null || variation === void 0 ? void 0 : variation.reducedCommissionRate) || 0) / 100;
    const vendorPriceExTaxExReducedCom = vendorPriceExTax - vendorPriceExTax * reducedCommissionRate;
    const vendorPriceExTaxExStandardCom = vendorPriceExTax - vendorPriceExTax * standardCommissionRate;
    const vendorSubtotalExTaxExReducedCom = vendorPriceExTaxExReducedCom * qty;
    const vendorSubtotalExTaxExStandardCom = vendorPriceExTaxExStandardCom * qty;
    return {
        unitPrice,
        unitPriceExTax,
        subtotal,
        subtotalExTax,
        vendorPrice,
        vendorPriceExTax,
        vendorSubtotal,
        vendorSubtotalExTax,
        vendorPriceTaxValue,
        vendorPriceExTaxExReducedCom,
        vendorPriceExTaxExStandardCom,
        vendorSubtotalExTaxExReducedCom,
        vendorSubtotalExTaxExStandardCom,
        vendorSubtotalTaxValue,
        subTotalTaxValue,
        unitPriceTaxValue,
    };
};
exports.calculateGmItemPrice = calculateGmItemPrice;
const calculateItemOptionSubtotal = (prices, leadItemQty, optionItemQty, optionType) => {
    const { price, priceExTax, taxValue } = prices;
    const multiplier = optionItemQty;
    return {
        price: (price || 0) * multiplier,
        priceExTax: (priceExTax || 0) * multiplier,
        taxValue: (taxValue || 0) * multiplier,
    };
};
exports.calculateItemOptionSubtotal = calculateItemOptionSubtotal;
const optionTotalReducer = (itemQty) => (total, { price, priceExTax, taxValue, qty, type, taxRate }) => {
    var _a, _b;
    const { price: calculatedPrice, priceExTax: calculatedPriceExTax, taxValue: calculatedTaxValue, } = (0, exports.calculateItemOptionSubtotal)({ price, priceExTax, taxValue }, itemQty, qty, type);
    const optionTaxRate = taxRate || 0;
    const existingTaxTotalForTaxRate = ((_a = total.taxRateBreakdown[optionTaxRate]) === null || _a === void 0 ? void 0 : _a.taxValue) || 0;
    const newTaxTotalForTaxRate = existingTaxTotalForTaxRate + calculatedTaxValue;
    const existingItemTotalForTaxRate = ((_b = total.taxRateBreakdown[optionTaxRate]) === null || _b === void 0 ? void 0 : _b.itemValue) || 0;
    const newItemTotalForTaxRate = existingItemTotalForTaxRate + calculatedPriceExTax;
    const newValuesForTaxRate = {
        taxValue: newTaxTotalForTaxRate,
        itemValue: newItemTotalForTaxRate,
    };
    return {
        price: total.price + calculatedPrice,
        priceExTax: total.priceExTax + calculatedPriceExTax,
        taxValue: total.taxValue + calculatedTaxValue,
        taxRateBreakdown: { ...total.taxRateBreakdown, [optionTaxRate]: newValuesForTaxRate },
    };
};
const calculateItemSubtotal = (prices, itemQty, options, variations) => {
    const { itemPrice, itemPriceExTax, itemTaxValue, itemTaxRate } = prices;
    const { subtotal: itemTotal, subtotalExTax: itemSubtotalExTax, subTotalTaxValue: itemSubTotalTaxValue, } = (0, exports.calculateGmItemPrice)({ price: itemPrice, priceExTax: itemPriceExTax, taxValue: itemTaxValue, variations }, itemQty);
    const { price: optionTotal, priceExTax: optionTotalExTax, taxValue: optionTaxValue, taxRateBreakdown: optionTaxRateBreakdown, } = options
        ? options.reduce(optionTotalReducer(itemQty), {
            price: 0,
            priceExTax: 0,
            taxValue: 0,
            taxRateBreakdown: {},
        })
        : { price: 0, priceExTax: 0, taxValue: 0, taxRateBreakdown: {} };
    const existingOptionTotalForItemRate = optionTaxRateBreakdown[itemTaxRate] || {
        taxValue: 0,
        itemValue: 0,
    };
    const newTotalsForItemRate = {
        taxValue: existingOptionTotalForItemRate.taxValue + itemSubTotalTaxValue,
        itemValue: existingOptionTotalForItemRate.itemValue + itemSubtotalExTax,
    };
    return {
        subtotal: itemTotal + optionTotal,
        subtotalExTax: itemSubtotalExTax + optionTotalExTax,
        subtotalTaxValue: itemSubTotalTaxValue + optionTaxValue,
        taxRateBreakdown: { ...optionTaxRateBreakdown, [itemTaxRate]: newTotalsForItemRate },
    };
};
exports.calculateItemSubtotal = calculateItemSubtotal;
// items subtotal
const calculateItemsSubtotal = (items, paramsMapping) => {
    if (items.length === 0) {
        return { subtotal: 0, subtotalExTax: 0, subtotalTaxValue: 0, subtotalTaxBreakdown: {} };
    }
    return items.reduce((accumulator, item) => {
        const { leadItemPrice, leadItemPriceExTax, leadItemTaxRate, leadItemQty, options, itemOptionParamsMapping, leadItemVariations, } = paramsMapping(item);
        const formattedOptions = options.map((option) => {
            const { price, optionItemQty, optionType, taxRate, taxValue, priceExTax } = itemOptionParamsMapping(option);
            return {
                price,
                priceExTax,
                qty: optionItemQty,
                type: optionType,
                taxRate,
                taxValue,
            };
        });
        const { taxRateBreakdown: itemTaxRateBreakdown } = (0, exports.calculateItemSubtotal)({
            itemPrice: leadItemPrice,
            itemPriceExTax: leadItemPriceExTax,
            itemTaxValue: leadItemPriceExTax * leadItemTaxRate,
            itemTaxRate: leadItemTaxRate,
        }, leadItemQty, formattedOptions, leadItemVariations);
        const newSubtotalTaxBreakdown = Object.keys(itemTaxRateBreakdown).reduce((acc, rate) => {
            var _a;
            const taxRate = Number(rate);
            const existingItemTotalForRate = ((_a = acc[taxRate]) === null || _a === void 0 ? void 0 : _a.itemValue) || 0;
            const newTotalsForRate = {
                itemValue: existingItemTotalForRate + itemTaxRateBreakdown[taxRate].itemValue,
                taxValue: (existingItemTotalForRate + itemTaxRateBreakdown[taxRate].itemValue) * taxRate,
            };
            return { ...acc, [taxRate]: newTotalsForRate };
        }, { ...accumulator.subtotalTaxBreakdown });
        const totals = Object.values(newSubtotalTaxBreakdown).reduce((t, a) => ({
            subtotal: t.subtotal + a.itemValue + a.taxValue,
            subtotalExTax: t.subtotalExTax + a.itemValue,
            subtotalTaxValue: t.subtotalTaxValue + a.taxValue,
        }), { subtotal: 0, subtotalExTax: 0, subtotalTaxValue: 0 });
        return {
            subtotal: totals.subtotal,
            subtotalExTax: totals.subtotalExTax,
            subtotalTaxValue: totals.subtotalTaxValue,
            subtotalTaxBreakdown: newSubtotalTaxBreakdown,
        };
    }, {
        subtotal: 0,
        subtotalExTax: 0,
        subtotalTaxValue: 0,
        subtotalTaxBreakdown: {},
    });
};
exports.calculateItemsSubtotal = calculateItemsSubtotal;
/**
 * Calculates the subtotal for a basket, with or without the commission values included
 * in the basket items variations, allowing the calculation to be made where access
 * to commission data is restricted
 * @param items an array of GmBasketItems, with variations including or excluding the commission values
 * @returns subtotals for the basket items
 */
const calculateBasketItemsSubtotal = (items) => {
    return (0, exports.calculateItemsSubtotal)(items, ({ item: leadItem, qty: leadItemQty, options }) => ({
        leadItemPrice: (leadItem === null || leadItem === void 0 ? void 0 : leadItem.price) || 0,
        leadItemPriceExTax: (leadItem === null || leadItem === void 0 ? void 0 : leadItem.priceExTax) || 0,
        leadItemTaxValue: (leadItem === null || leadItem === void 0 ? void 0 : leadItem.taxValue) || 0,
        leadItemTaxRate: (leadItem === null || leadItem === void 0 ? void 0 : leadItem.taxRate) || 0,
        leadItemQty,
        options,
        itemOptionParamsMapping: exports.basketItemOptionSubtotalParamsMapping,
        leadItemVariations: leadItem === null || leadItem === void 0 ? void 0 : leadItem.variations,
    }));
};
exports.calculateBasketItemsSubtotal = calculateBasketItemsSubtotal;
